// extracted by mini-css-extract-plugin
export default {"container":"MainCarousel_container__T5U7l","mainSwiper":"MainCarousel_mainSwiper__HMG2r"};